import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-32 px-4 bg-gradient-to-b from-cream-50 to-amber-50 relative overflow-hidden" data-id="element-190">
      {/* Soft warm glow in background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-200/30 rounded-full blur-3xl pointer-events-none" data-id="element-191"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-193">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-navy-950 mb-10" data-id="element-194">
            ¿Qué cambia en 7 días?
          </h2>

          <div className="bg-white/80 backdrop-blur-md p-8 md:p-12 rounded-3xl shadow-xl border border-amber-100" data-id="element-195">
            <p className="text-xl md:text-2xl text-navy-800 font-body leading-relaxed mb-6 font-light" data-id="element-196">
              Imagina despertar el próximo lunes después de haber dormido 6
              horas seguidas.
            </p>
            <p className="text-lg md:text-xl text-navy-700 font-body leading-relaxed mb-6" data-id="element-197">
              El café vuelve a saber bien, tienes paciencia para jugar en el
              suelo con tu hijo y esa sensación de "nudo en la garganta" por el
              agotamiento ha desaparecido.
            </p>
            <div className="h-px w-24 bg-amber-300 mx-auto my-8" data-id="element-198"></div>
            <p className="text-xl md:text-2xl text-navy-900 font-display font-bold leading-relaxed" data-id="element-199">
              En una semana, tu bebé pasará de necesitarte para cada
              micro-despertar a calmarse solo en menos de 5 minutos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}